var r="4.17.5";export{r as version};
//# sourceMappingURL=package.json.js.map
